module.exports = __webpack_public_path__ + "static/media/5.a3f45ba2.webp";